/* tslint:disable: variable-name */
/* Must directly match with the case-sensitive data returned from the API. */

import { MarketplaceItemStatus } from './marketplace-item-status';
import { MarketplaceItem } from './marketplace-item.model';

export class MarketplaceItemExtended extends MarketplaceItem {
  Status: MarketplaceItemStatus;

  static [Symbol.hasInstance](instance: any): instance is MarketplaceItemExtended {
    return 'ProductItemId' in instance && typeof instance.ProductItemId === 'number';
  }
}
